<template>
  <form @submit.prevent="handleSubmit(onSubmit)">
    <div class="row">

      <div class="col-4">

        <div class="form-group row">
          <label :for="id + '-hazmatCode-code'" class="col-3 col-form-label">{{ $t('hazmat-code.identifier') }}</label>
          <div class="col-9">
            <e-form-text :id="id + '-hazmatCode-code'" :value="entity.code"/>
          </div>
        </div>

      </div>

      <div class="col-4">

        <div class="form-group row">
          <label :for="id + '-hazmatCode-name'" class="col-3 col-form-label">{{ $t('hazmat-code.label') }}</label>
          <div class="col-9">
            <e-form-text :id="id + '-hazmatCode-name'" :value="entity.name"/>
          </div>
        </div>

      </div>
      
    </div>
  </form>
</template>

<script>

import service from "@/services/hazmatCode.service";
import {log} from "@emons/emons-vue"

export default {
  name: "HazmatCodeView",
  components: {},
  mounted() {
    log('debug', 'Mounted HazmatCodeView...')
    this.getEntityDetails()
  },
  props: {
    id: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      entity: {
        abbreviation: null,
        name: null,
        international: null
      }
    }
  },
  methods: {
    getEntityDetails: function () {
      this.$emit('enableSpinner');
      service
          .getEntityDetails(this.link)
          .then(response => {
            this.entity = response.data
            this.$emit('disableSpinner');
          })
    }
  }
}
</script>

<style scoped>

</style>